import React from "react";

const CharacterContext = React.createContext();
export default CharacterContext;
